/* eslint-disable promise/prefer-await-to-callbacks */
import axios, { AxiosInstance } from 'axios';
import injectAuthorization from './injectAuthorization';
import injectUnauthorizedLogout from './injectUnauthorizedLogout';
import injectDefaultHeaders from './injectDefaultHeaders';

/**
 * The network client used to fetch blob responses from the api. It will transform
 * incomming array buffers to a pdf
 */
const PdfClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  responseType: 'arraybuffer',
  headers: {
    Accept: 'application/pdf',
  },
  transformResponse: (data) => new Blob([data]),
});

PdfClient.interceptors.request.use(injectDefaultHeaders);
PdfClient.interceptors.request.use(injectAuthorization);
PdfClient.interceptors.response.use(
  (response) => response,
  (error) => {
    injectUnauthorizedLogout(error);

    // Rethrow the error, so that processRequest can catch it
    throw error;
  },
);

export default PdfClient;
